import {
  ButtonGrayOutline,
  ButtonNegative,
  ButtonsWrapper,
  ContentWrapper,
  DeleteIcon,
  FeaturedWrapper,
  Message,
  MessageBody,
  MessageHeader,
} from '../Modal.styles';
import { GenericDeleteModalPropTypes } from './GenericDeleteModal.styles';

export function GenericDeleteModal({
  onCancelHandler,
  onDeleteHandler,
}: GenericDeleteModalPropTypes): JSX.Element {
  return (
    <ContentWrapper>
      <FeaturedWrapper>
        <DeleteIcon width={94} height={100} />
      </FeaturedWrapper>
      <Message>
        <MessageHeader>Wait!</MessageHeader>
        <MessageBody>
          Thinking of deleting? No going back from here!
        </MessageBody>
      </Message>
      <ButtonsWrapper>
        <ButtonGrayOutline onClick={onCancelHandler}>Cancel</ButtonGrayOutline>
        <ButtonNegative onClick={onDeleteHandler}>Delete</ButtonNegative>
      </ButtonsWrapper>
    </ContentWrapper>
  );
}
